export default __webpack_public_path__ + "static/media/meeting_step_3.b00999b5.svg";